import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Directory } from '../../interfaces/directory.interface';

export interface DirectoryMetadata {
    id?: string;
    fileCount: number;
    totalSize: string;
}

@Injectable({ providedIn: 'root' })
export class DirectoryStateService {
    private readonly selectedDirectory$ = new BehaviorSubject<Directory | null>(null);

    setSelected(directory: Directory | null): void {
        this.selectedDirectory$.next(directory);
    }

    getSelected$(): Observable<Directory | null> {
        return this.selectedDirectory$.asObservable();
    }

    getSelected(): Directory | null {
        return this.selectedDirectory$.getValue();
    }
}
